// Polyfill
if (!String.prototype.includes) {
    String.prototype.includes = function(search, start) {
        'use strict';
        if (search instanceof RegExp) {
            throw TypeError('first argument must not be a RegExp');
        }
        if (start === undefined) { start = 0; }
        return this.indexOf(search, start) !== -1;
    };
}

document.querySelectorAll('input[name="measurements[]"]').forEach(item => {
    item.addEventListener('change', event => {
        event.preventDefault();

        let name = item.value;
        let active = item.checked;

        let methodLabel = item.getAttribute('data-method-label');
        if (active && methodLabel && window.plausible)
            plausible('Set Method Filter', {props: {label: methodLabel}});

        let selectedMethods = document.querySelectorAll('input[name="measurements[]"]:checked');
        let selectedMethodValues = [];
        for (let selectedMethod of selectedMethods) {
            selectedMethodValues.push(selectedMethod.value);
        }

        document.querySelectorAll('[data-measurement-method="' + name + '"]').forEach(item => {
            if (active) {
                item.classList.add('d-flex');
                item.classList.remove('d-none');
            } else {
                item.classList.add('d-none');
                item.classList.remove('d-flex');
            }
        });

        let matchingProducts = false;
        document.querySelectorAll('[data-product]').forEach(item => {

            let firstCheckedItem = document.querySelector('input[name="measurements[]"]:checked');

            let productMethods = item.querySelectorAll('[data-measurement-method]');
            let productMethodValues = [];
            for (let productMethod of productMethods) {
                productMethodValues.push(productMethod.getAttribute('data-measurement-method'));
            }

            let productSupportsMethods = (arr, target) => target.every(v => arr.includes(v));
            if(productSupportsMethods(productMethodValues, selectedMethodValues) || !firstCheckedItem) {
                item.classList.add('d-block');
                item.classList.remove('d-none');
                matchingProducts = true;
            } else {
                item.classList.add('d-none');
                item.classList.remove('d-block');
            }
        });

        let noResultAlert = document.querySelector('[data-measurement-filter="no-result"]');
        if (noResultAlert && matchingProducts === false) {
            noResultAlert.classList.add('d-block');
            noResultAlert.classList.remove('d-none');
        } else {
            noResultAlert.classList.add('d-none');
            noResultAlert.classList.remove('d-block');
        }

    }, false);
});
